module.exports = "/images/ru.svg?33d085f4596c35125d508b0b926f403f";